import { CardContent, Grid } from '@mui/material';
import CommonPdfAndImageVeiw from '../../../../../Components/pdfAndImageView/CommonPdfAndImageVeiw';
import { IPayemntListType } from '../api/paymentApi';
import CommonDetailItem, {
  formatDate,
  formatValue,
} from '../../../../../Components/CommonDetailItem/CommonDetailItem';

type IProps = {
  data: IPayemntListType;
};

const labelWidth = { xs: '120px', sm: '150px', md: '160px' };

const OfflinePaymentCardInformation = ({ data }: IProps) => {
  const isOnline = data?.type === 'online';

  return (
    <>
      {data && (
        <CardContent sx={{ p: 1, '&:last-child': { pb: 1 } }}>
          <Grid container rowSpacing={1} columnSpacing={2}>
            {isOnline ? (
              <>
                <CommonDetailItem
                  xs={12}
                  sm={6}
                  md={6}
                  labelWidth={labelWidth}
                  label='Payment Type'
                  value={formatValue(data?.type)}
                />
                <CommonDetailItem
                  xs={12}
                  sm={6}
                  md={6}
                  labelWidth={labelWidth}
                  label='Payment Method'
                  value={formatValue(data?.bank_name)}
                />
                <CommonDetailItem
                  xs={12}
                  sm={6}
                  md={6}
                  labelWidth={labelWidth}
                  label='Amount'
                  value={
                    data?.amount
                      ? `${Number(data.amount).toLocaleString()} BDT`
                      : 'N/A'
                  }
                />
                <CommonDetailItem
                  xs={12}
                  sm={6}
                  md={6}
                  labelWidth={labelWidth}
                  label='Payment Date'
                  value={formatDate(
                    data?.payment_date,
                    'Do-MM-YYYY, h:mm:ss a',
                  )}
                />
                <CommonDetailItem
                  xs={12}
                  sm={6}
                  md={6}
                  labelWidth={labelWidth}
                  label='Ref No'
                  value={formatValue(data?.reference_no)}
                />
                <CommonDetailItem
                  xs={12}
                  sm={6}
                  md={6}
                  labelWidth={labelWidth}
                  label='Transaction No'
                  value={formatValue(data?.tran_id)}
                />
                <CommonDetailItem
                  xs={12}
                  sm={6}
                  md={6}
                  labelWidth={labelWidth}
                  label='Status'
                  value={formatValue(data?.status)}
                />
              </>
            ) : (
              <>
                {/* <CommonDetailItem
                  xs={12}
                  sm={6}
                  md={6}
                  labelWidth={labelWidth}
                  label='Account No'
                  value={formatValue(data?.bank_ac_no)}
                /> */}
                <CommonDetailItem
                  xs={12}
                  sm={6}
                  md={6}
                  labelWidth={labelWidth}
                  label='Amount'
                  value={
                    data?.amount
                      ? `${Number(data.amount).toLocaleString()} BDT`
                      : 'N/A'
                  }
                />
                <CommonDetailItem
                  xs={12}
                  sm={6}
                  md={6}
                  labelWidth={labelWidth}
                  label='Deposit Date'
                  value={formatDate(data?.deposit_date, 'Do-MM-YYYY')}
                />
                {/* <CommonDetailItem
                  xs={12}
                  sm={6}
                  md={6}
                  labelWidth={labelWidth}
                  label='Bank Name'
                  value={formatValue(data?.bank_name)}
                /> */}
                <CommonDetailItem
                  xs={12}
                  sm={6}
                  md={6}
                  labelWidth={labelWidth}
                  label='Branch Name'
                  value={formatValue(data?.branch_name)}
                />
                <CommonDetailItem
                  xs={12}
                  sm={6}
                  md={6}
                  labelWidth={labelWidth}
                  label='Upload Bank Slip'
                  value={
                    data?.bank_slip ? (
                      <CommonPdfAndImageVeiw
                        file={data.bank_slip}
                        fileName='View Bank Slip'
                      />
                    ) : (
                      'N/A'
                    )
                  }
                />
                <CommonDetailItem
                  xs={12}
                  sm={6}
                  md={6}
                  labelWidth={labelWidth}
                  label='Reference No'
                  value={formatValue(data?.reference_no)}
                />
                <CommonDetailItem
                  xs={12}
                  sm={6}
                  md={6}
                  labelWidth={labelWidth}
                  label='Transaction No'
                  value={formatValue(data?.tran_id)}
                />
                <CommonDetailItem
                  xs={12}
                  sm={6}
                  md={6}
                  labelWidth={labelWidth}
                  label='Payment Type'
                  value={formatValue(data?.type)}
                />
              </>
            )}
          </Grid>
        </CardContent>
      )}
    </>
  );
};

export default OfflinePaymentCardInformation;
